const legalMapping = {
    en: {
        1: 'Published',
        2: 'Examining',
        3: 'Granted',
        8: 'Double',
        11: 'Withdrawn',
        13: 'Rejected',
        14: 'Revoked',
        15: 'Expired',
        16: 'Non-payment',
        21: 'Restoration',
        22: 'Ceased',
        23: 'P-Revoked',
        30: 'Abandoned',
        61: 'Transfer',
        62: 'License',
        63: 'Pledge',
        64: 'Trust',
        65: 'Opposition',
        66: 'Re-examination',
        68: 'P-Revoked',
        69: 'Customs',
        70: 'Litigation',
        71: 'Preservation',
        72: 'Invalid-procedure',
        73: 'Oral-procedure',
        74: 'Declassification'
    },
    cn: {
        1: '公开',
        2: '实质审查',
        3: '授权',
        8: '避重授权',
        11: '撤回',
        13: '驳回',
        14: '全部撤销',
        15: '期限届满',
        16: '未缴年费',
        21: '权利恢复',
        22: '权利终止',
        23: '部分无效',
        30: '放弃',
        61: '权利转移',
        62: '许可',
        63: '质押',
        64: '信托',
        65: '异议',
        66: '复审',
        68: '部分无效',
        69: '海关备案',
        70: '诉讼',
        71: '保全',
        72: '无效程序',
        73: '口头审理',
        74: '国防解密'
    },
    tw: {
        1: '公開',
        2: '實質審查',
        3: '授權',
        8: '避重授權',
        11: '撤回',
        13: '駁回',
        14: '全部撤銷',
        15: '期限屆滿',
        16: '未繳年費',
        21: '權利恢復',
        22: '權利終止',
        23: '部分無效',
        30: '放棄',
        61: '權利轉移',
        62: '許可',
        63: '質押',
        64: '信託',
        65: '異議',
        66: '復審',
        68: '部份無效',
        69: '海關備案',
        70: '訴訟',
        71: '保全',
        72: '無效程序',
        73: '口頭審理',
        74: '國防解密'
    },
    jp: {
        1: '公開',
        2: '審査係属中',
        3: '登録',
        8: '二重特許',
        11: '取下',
        13: '拒絶査定',
        14: '全部無効',
        15: '期間満了',
        16: '年金不納',
        21: '権利回復',
        22: '権利消滅',
        23: '一部無効',
        30: '放棄',
        61: '譲渡',
        62: '特許',
        63: '質権',
        64: '信託',
        65: '異議',
        66: '再審',
        68: '一部無効',
        69: '輸入差止申立',
        70: '訴訟',
        71: '保全',
        72: '無効判定',
        73: '口頭審理',
        74: '機密解除'
    },
    de: {
        1: 'Offen',
        2: 'Überprüfung',
        3: 'Ermächtigen',
        8: 'Vermeiden Vervielfältigung der Ermächtigung',
        11: 'Zurückziehen mit Initiative',
        13: 'Zurückweisen',
        14: 'Alles ungültig',
        15: 'Abgelaufen',
        16: 'Unbezahlte Jahresgebühr',
        21: 'Restauration',
        22: 'Aufgehört',
        23: 'P-widerrufen',
        30: 'Aufgeben',
        61: 'Übertragung',
        62: 'Lizenz',
        63: 'Versprechen',
        64: 'Vertrauen',
        65: 'Einwand',
        66: 'Wieder prüfen',
        68: 'Teilweise ungültig',
        69: 'Customs',
        70: 'Rechtsstreitigkeiten',
        71: 'Erhaltung',
        72: 'Ungültige Prozedur',
        73: 'Mündliche Verhandlung',
        74: 'Freigabe'
    }
};

export default legalMapping;
